import { useIntl } from 'react-intl';

import { KeyFeatures } from '@/components/KeyFeatures';
import type { ContentfulPlaceholderFragment } from '@/graphql/contentful/api';
import {
  type StrapAttributesFragment,
  type StrapBuckleSizesQuery,
} from '@/graphql/saleor/api';
import type { PlaceholderType } from '@/integrations/contentful';
import type { Maybe } from '@/lib/types';

import { getBuckleSize, getKeyFeatures } from './utils';

export interface KeyFeaturesOpts {
  buckleSizesData: StrapBuckleSizesQuery;
  product: Maybe<StrapAttributesFragment>;
  type: PlaceholderType;
  withSectionMargin?: boolean;
}

export type KeyFeaturesSectionProps = KeyFeaturesOpts &
  ContentfulPlaceholderFragment;

export const KeyFeaturesSection = ({
  buckleSizesData,
  heading,
  product,
  type,
  withSectionMargin,
}: KeyFeaturesSectionProps) => {
  const { formatMessage } = useIntl();
  const keyFeatures = getKeyFeatures(
    product!,
    getBuckleSize(buckleSizesData),
    formatMessage,
  );

  return (
    <KeyFeatures
      data-test-id='KeyFeaturesSection'
      type={type}
      withSectionMargin={withSectionMargin}
    >
      <KeyFeatures.Header
        data-test-id='KeyFeaturesSectionHeader'
        heading={heading}
      />
      <KeyFeatures.Features
        data-test-id='KeyFeaturesSectionFeatures'
        keyFeatures={keyFeatures}
        loading={false}
      />
    </KeyFeatures>
  );
};

KeyFeaturesSection.displayName = 'KeyFeaturesSection';
